import ClayForm, { ClayInput } from "@clayui/form";
import "./GlobalInput.css";
import {
  UseFormRegister,
  FieldValues,
  FieldErrors,
  UseFormSetError,
  UseFormClearErrors,
} from "react-hook-form";
import React, { useState } from "react";
interface InputProps {
  classname?: string;
  label?: string;
  type: string;
  name: string;
  placeholder: string;
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
  required?: boolean;
  disabled?: boolean;
  defaultValue?: any;
  component?:
  | "input"
  | "textarea"
  | React.ForwardRefExoticComponent<any>
  | undefined;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  setError?: UseFormSetError<FieldValues>;
  clearErrors?: UseFormClearErrors<FieldValues>;
  desc?:string;
  errorText?:string
}

const GlobalInput: React.FC<InputProps> = ({
  label,
  type,
  name,
  placeholder,
  register,
  errors,
  required,
  disabled,
  classname,
  component,
  defaultValue,
  onBlur,
  setError,
  clearErrors,
  desc,
  errorText
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const emailPattern = {
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Invalid email format",
    },
  };
 
  return (
    <ClayForm.Group
    className="roadshow"
    >
      {label && (
        <label htmlFor={name} className={(name === 'eventDate') ? "custom_label_diabled" : "custom_label"}>
          {(() => {
            if (desc) {
              return (
                <>
                  {label} <i className="i-font">{desc}</i>
                </>
              );
            } else {
              return label;
            }
          })()}
        </label>
      )}

      <ClayInput
        id={name}
        type={type === "password" && showPassword ? "text" : type}
        placeholder={placeholder}
        {...register(name, {
          required: required && `${errorText? errorText : label?.replaceAll("*", "")} is required`,
          validate: (value: any) => {
            if (typeof value === 'string' && value.trim().length === 0) {
              return 'Blank or whitespace-only values are not allowed';
            }
            if (type === "number") {
              return value > 0 || "Please enter a valid positive number";
            }
            return true;
          },
          ...(name === "email" && {
            pattern: emailPattern.pattern
          })
        })}
        component={component}
        defaultValue={defaultValue}
        disabled={disabled}
        className={
          errors[name]
            ? "is-invalid"
            : `${type === "number" && "no-spinner"} custom_input ${classname}`
        }
        onBlur={onBlur}
      />

      {type === "password" &&
        !errors[name] && (
          <span className="password-toggle-icon mt-3" onClick={togglePasswordVisibility}>
            {showPassword ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.004 15.154C13.02 15.154 13.882 14.7983 14.59 14.087C15.298 13.3757 15.6524 12.5117 15.653 11.495C15.6537 10.4783 15.298 9.61633 14.586 8.909C13.874 8.20167 13.01 7.84733 11.994 7.846C10.978 7.84467 10.1164 8.20033 9.40905 8.913C8.70172 9.62567 8.34738 10.4897 8.34605 11.505C8.34472 12.5203 8.70038 13.3823 9.41305 14.091C10.1257 14.7997 10.9887 15.154 12.004 15.154ZM11.999 14.2C11.249 14.2 10.6117 13.9377 10.087 13.413C9.56238 12.8883 9.29972 12.2507 9.29905 11.5C9.29838 10.7493 9.56105 10.112 10.087 9.588C10.6131 9.064 11.2504 8.80133 11.999 8.8C12.7477 8.79867 13.3854 9.06133 13.912 9.588C14.4387 10.1147 14.701 10.752 14.699 11.5C14.697 12.248 14.4347 12.8857 13.912 13.413C13.3894 13.9403 12.7517 14.2027 11.999 14.2ZM11.999 18C10.0224 18 8.20905 17.4767 6.55905 16.43C4.90905 15.3833 3.57672 14.0117 2.56205 12.315C2.47872 12.1783 2.41972 12.0433 2.38505 11.91C2.35038 11.7767 2.33272 11.6397 2.33205 11.499C2.33138 11.3583 2.34905 11.2217 2.38505 11.089C2.42105 10.9563 2.48005 10.8217 2.56205 10.685C3.57805 8.987 4.91072 7.615 6.56005 6.569C8.20938 5.523 10.0224 5 11.999 5C13.9757 5 15.7891 5.52333 17.439 6.57C19.0891 7.61667 20.4214 8.98833 21.4361 10.685C21.5194 10.8217 21.5784 10.9567 21.6131 11.09C21.6477 11.2233 21.6654 11.3603 21.666 11.501C21.6667 11.6417 21.649 11.7783 21.6131 11.911C21.5771 12.0437 21.5181 12.1783 21.4361 12.315C20.4207 14.013 19.088 15.385 17.438 16.431C15.7887 17.477 13.9757 17.9993 11.999 17.9993V18ZM11.999 17C13.8824 17 15.6117 16.5043 17.187 15.513C18.7624 14.5217 19.9664 13.184 20.799 11.5C19.9657 9.81667 18.7614 8.47933 17.186 7.488C15.6107 6.49667 13.8817 6.00067 11.999 6C10.1164 5.99933 8.38738 6.49533 6.81205 7.488C5.23672 8.48067 4.03238 9.818 3.19905 11.5C4.03238 13.1833 5.23672 14.521 6.81205 15.513C8.38738 16.505 10.1164 17.0007 11.999 17Z" fill="white"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.004 15.154C13.02 15.154 13.882 14.7983 14.59 14.087C15.298 13.3757 15.6524 12.5117 15.653 11.495C15.6537 10.4783 15.298 9.61633 14.586 8.909C13.874 8.20167 13.01 7.84733 11.994 7.846C10.978 7.84467 10.1164 8.20033 9.40905 8.913C8.70172 9.62567 8.34738 10.4897 8.34605 11.505C8.34472 12.5203 8.70038 13.3823 9.41305 14.091C10.1257 14.7997 10.9887 15.154 12.004 15.154ZM11.999 14.2C11.249 14.2 10.6117 13.9377 10.087 13.413C9.56238 12.8883 9.29972 12.2507 9.29905 11.5C9.29838 10.7493 9.56105 10.112 10.087 9.588C10.6131 9.064 11.2504 8.80133 11.999 8.8C12.7477 8.79867 13.3854 9.06133 13.912 9.588C14.4387 10.1147 14.701 10.752 14.699 11.5C14.697 12.248 14.4347 12.8857 13.912 13.413C13.3894 13.9403 12.7517 14.2027 11.999 14.2ZM11.999 18C10.0224 18 8.20905 17.4767 6.55905 16.43C4.90905 15.3833 3.57672 14.0117 2.56205 12.315C2.47872 12.1783 2.41972 12.0433 2.38505 11.91C2.35038 11.7767 2.33272 11.6397 2.33205 11.499C2.33138 11.3583 2.34905 11.2217 2.38505 11.089C2.42105 10.9563 2.48005 10.8217 2.56205 10.685C3.57805 8.987 4.91072 7.615 6.56005 6.569C8.20938 5.523 10.0224 5 11.999 5C13.9757 5 15.7891 5.52333 17.439 6.57C19.0891 7.61667 20.4214 8.98833 21.4361 10.685C21.5194 10.8217 21.5784 10.9567 21.6131 11.09C21.6477 11.2233 21.6654 11.3603 21.666 11.501C21.6667 11.6417 21.649 11.7783 21.6131 11.911C21.5771 12.0437 21.5181 12.1783 21.4361 12.315C20.4207 14.013 19.088 15.385 17.438 16.431C15.7887 17.477 13.9757 17.9993 11.999 17.9993V18ZM11.999 17C13.8824 17 15.6117 16.5043 17.187 15.513C18.7624 14.5217 19.9664 13.184 20.799 11.5C19.9657 9.81667 18.7614 8.47933 17.186 7.488C15.6107 6.49667 13.8817 6.00067 11.999 6C10.1164 5.99933 8.38738 6.49533 6.81205 7.488C5.23672 8.48067 4.03238 9.818 3.19905 11.5C4.03238 13.1833 5.23672 14.521 6.81205 15.513C8.38738 16.505 10.1164 17.0007 11.999 17Z" fill="white"/>
            </svg>
          )}
        </span>
      )}

      {errors[name] && (
        <div className="invalid-feedback" style={{ display: "block", fontSize: '14px', fontWeight: '700' }}>
          {errors[name]?.message as string}
        </div>
      )}
    </ClayForm.Group>
  );
};
export default GlobalInput;
